<template>
    <div>
        <div class="next-appointment-link">
            <div class="text-center">
                <button type="button" role="button" class="btn btn-primary btn-next" @click.prevent="submit">
                    Show next available
                </button>
            </div>
        </div>

        <no-appointments-available :id="clinic.ClinicID"></no-appointments-available>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    import NoAppointmentsAvailable from './NoAppointmentsAvailable';

    export default {
        name: 'next-available-appointments',

        components: {
            NoAppointmentsAvailable,
        },

        props: {
            clinic: {
                type: Object,
                required: true,
            },
        },

        methods: {
            ...mapActions('appointments', [
                'getNextAvailableAppointments',
            ]),

            data() {
                return {
                    submitting: false,
                };
            },

            submit() {
                if (this.submitting) {
                    return;
                }

                this.submitting = true;

                this.getNextAvailableAppointments({
                    clinic: this.clinic,
                    callback: (data) => {
                        this.submitting = false;

                        if (data && !data.length) {
                            this.showModal(`no-appt-available-${this.clinic.ClinicID}`);
                        }
                    },
                });
            },
        },
    }
</script>
